import React, { FunctionComponent } from 'react';
import { HeaderFieldSchema, HeaderField } from '../dynamicFormSchema';
import { DynamicFieldProps } from '../DynamicField';
import { DynamicFieldComponent } from './DynamicFieldComponentBase';
import { Heading, Text } from '../../Typography';

export const GroupHeaderFieldComponent: FunctionComponent<DynamicFieldProps> = ({ field }) => {
  const h = HeaderFieldSchema.parse(field);

  return (
    <div className="flex flex-col border-b pb-2">
      <Heading level="section" as="h3" className="mb-3 mt-6">
        {h.title}
      </Heading>
      {h.description && (
        <Text size="sm" tone="muted">
          {h.description}
        </Text>
      )}
    </div>
  );
};

export class DynamicHeaderField extends DynamicFieldComponent<HeaderField, undefined> {
  Component = GroupHeaderFieldComponent;

  constructor(field: HeaderField) {
    super(field);
  }

  getAnswer(): undefined {
    throw new Error('Header fields do not have an answer');
  }

  getDefaultValue(): undefined {
    throw new Error('Header fields do not have a default value');
  }

  getValueToSubmit(): undefined {
    throw new Error('Header fields do not have a value to submit');
  }

  providesAnswer(): boolean {
    return false;
  }
}
